export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/index.js
// module id = 213
// module chunks = 0